export var ProjectName = 'payment-methods';
var CDN_URL_PROD = 'https://c.cheggcdn.com/assets/';
export var CHEGG_CLOUDINARY_CDN = 'https://assets.chegg.com';
export var AppProductionConfigs = {
  cdnUrl: CDN_URL_PROD,
  flagUrl: "".concat(CDN_URL_PROD, "site/flag-icons/"),
  braintreeToken: 'production_6mhyzqmw_k588b3w67tw7q2zs',
  paypalClientId: 'APP-80W284485P519543T',
  applePayJSVersion: 3,
  billdesk: {
    merchantId: 'CHEGGV2',
    scriptsSubDomain: 'pay'
  },
  recurly: {
    publicKey: 'ewr1-X1JthhZsGHBPyCVNoFOBwl',
    braintreeToken: 'production_gpqftjcz_k588b3w67tw7q2zs'
  },
  googlePay: {
    merchantId: 'BCR2DN4TZLZ4RNZH',
    googlePayVersion: 2,
    googlePayURL: 'https://pay.google.com/gp/p/js/pay.js'
  }
};
export var AppDevConfigs = {
  cdnUrl: CDN_URL_PROD,
  flagUrl: "".concat(CDN_URL_PROD, "site/flag-icons/"),
  braintreeToken: 'sandbox_kt2y5ndj_2jmd2mjtkn5f3fkp',
  paypalClientId: 'APP-80W284485P519543T',
  applePayJSVersion: 3,
  billdesk: {
    merchantId: 'UATCHEGGV2',
    scriptsSubDomain: 'uat1'
  },
  recurly: {
    publicKey: 'ewr1-rL8PbPULqZDdJGFLf4vfYy',
    braintreeToken: 'sandbox_w328htkj_2jmd2mjtkn5f3fkp'
  },
  googlePay: {
    merchantId: 'sandbox-merchant-id',
    googlePayVersion: 2,
    googlePayURL: 'https://pay.google.com/gp/p/js/pay.js'
  }
};
export var UILayout = /*#__PURE__*/function (UILayout) {
  UILayout["FULL"] = "full";
  return UILayout;
}({});
export var Processors = /*#__PURE__*/function (Processors) {
  Processors["BRAINTREE"] = "braintree";
  Processors["BILLDESK"] = "billdesk";
  Processors["ADYEN"] = "adyen";
  Processors["RECURLY"] = "recurly";
  return Processors;
}({});
export var PaymentTypes = /*#__PURE__*/function (PaymentTypes) {
  PaymentTypes["CREDITCARD"] = "creditcard";
  PaymentTypes["APPLEPAY"] = "applepay";
  PaymentTypes["PAYPAL"] = "paypal";
  PaymentTypes["YIFTEE"] = "yiftee";
  PaymentTypes["VENMO"] = "venmo";
  PaymentTypes["UPI"] = "upi";
  PaymentTypes["GOOGLE_PAY"] = "GOOGLE_PAY";
  PaymentTypes["PLACEHOLDER"] = "placeholder";
  return PaymentTypes;
}({});
export var CurrencyCodes = /*#__PURE__*/function (CurrencyCodes) {
  CurrencyCodes["USD"] = "USD";
  CurrencyCodes["CAD"] = "CAD";
  CurrencyCodes["AUD"] = "AUD";
  CurrencyCodes["SGD"] = "SGD";
  CurrencyCodes["MXN"] = "MXN";
  CurrencyCodes["INR"] = "INR";
  CurrencyCodes["CNY"] = "CNY";
  CurrencyCodes["GBP"] = "GBP";
  CurrencyCodes["EUR"] = "EUR";
  CurrencyCodes["TRY"] = "TRY";
  CurrencyCodes["KRW"] = "KRW";
  CurrencyCodes["IDR"] = "IDR";
  CurrencyCodes["PHP"] = "PHP";
  CurrencyCodes["MYR"] = "MYR";
  CurrencyCodes["HKD"] = "HKD";
  CurrencyCodes["ZAR"] = "ZAR";
  CurrencyCodes["SAR"] = "SAR";
  CurrencyCodes["AED"] = "AED";
  CurrencyCodes["NZD"] = "NZD";
  return CurrencyCodes;
}({});
export var CHECKOUT_FLOW = {
  VAULT: 'vault'
};
export var Referrer = /*#__PURE__*/function (Referrer) {
  Referrer["DCO"] = "DCO";
  Referrer["MY_ACCOUNT"] = "my-account";
  Referrer["ONE_CLICK"] = "one-click";
  return Referrer;
}({});
export var Zipcode = /*#__PURE__*/function (Zipcode) {
  Zipcode["ABCDE"] = "abcde";
  Zipcode["ALL_ONES"] = "11111";
  Zipcode["GB"] = "AB1 2CD";
  return Zipcode;
}({});
export var PAY_W_UPI_ICON = "".concat(CDN_URL_PROD, "site/icons/upi-logo.png");

// According to tax team and Recurly, empty address attributes should be set to - instead of null or undefined
export var EMPTY_ADDRESS_VALUE = '-';

// Merchant country that we are based on according to Recurly
export var MERCHANT_COUNTRY = 'US';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/constants/AppConstants.js
// module id = 93
// module chunks = 11